/* eslint-disable @typescript-eslint/naming-convention */
interface AppStorageLabel {
  APP_VERSION: string;
  SETTINGS: string;

  GLOBAL_CATALOGS: string;
  PRODUCT_ITEMS: string;

  CLIENTS: string;
  CLIENTS_FOR_FILTERS: string;
  COLLABORATORS: string;
  LINES: string;
  SEGMENTS: string;
  SPECIALTIES: string;
  SOCIAL_MEDIAS: string;

  DISPATCHERS: string;
  ITEMS: string;
  FORMS: {
    ORDERS: string;
    APPOINTMENTS: string;
    STAKEHOLDERS: string;
    CUSTOMERS: string;
  };
  ACTIVE_CAMPAIGNS: string;
  CAMPAIGNS: string;
  CAMPAIGN_RESOURCES: string;

  MY_FORMS: string;

  SESSION: string;
  USER: string;
  USERNAME: string;
  COMPANY: string;
  COMPANY_TYPE: string;
  COLLABORATOR: string;
  OPTIONS_MENU: string;
  AI_CHAT_HISTORY: string;

  SETTINGS_LANGUAGE: string;
  SETTINGS_FORMAT: string;
  SETTINGS_PRECISION: string;

  CACHE_KEYS: string;

  /** @deprecated Use User property instead */
  IS_LOGGED: string;

  /** @deprecated Use User property instead */
  AGENT?: string;
  /** @deprecated Use Company property instead */
  REST?: string;
  /** @deprecated Use Company property instead */
  LANGUAGE?: string;
  /** @deprecated Use User property instead */
  CLIENTS_PER_AGENT?: string;
  /** @deprecated Use User property instead */
  ITEMS_PER_AGENT?: string;
  /** @deprecated Use User property instead */
  DISPATCHERS_PER_AGENT?: string;
  PUSH_ID: string;
  /** @deprecated Use User property instead */
  SALESFORCE_RESULT: string;
  /** @deprecated Use User property instead */
  FILTERS_CLIENTS: string;
  /** @deprecated Use User property instead */
  FILTERS_LINES: string;
  /** @deprecated Use User property instead */
  FILTERS_SEGMENTS: string;
  /** @deprecated Use User property instead */
  FILTERS_SALESFORCE: string;
  /** @deprecated Use User property instead */
  FILTERS_DASHBOARD_R: string;
  /** @deprecated Use User property instead */
  REST_ENDPOINTS: string;
  /** @deprecated Use User property instead */
  LICENSE_INFORMATION: string;
}

export const AppStorage: AppStorageLabel = {
  APP_VERSION: 'P360.AppVersion',

  SETTINGS: 'P360.Settings',

  GLOBAL_CATALOGS: 'P360.GlobalCatalogs',
  PRODUCT_ITEMS: 'P360.ProductItems',

  CLIENTS: 'P360.Clients',
  CLIENTS_FOR_FILTERS: 'P360.ClientsForFilters',
  COLLABORATORS: 'P360.Collaborators',
  LINES: 'P360.Lines',
  SEGMENTS: 'P360.Segments',
  SPECIALTIES: 'P360.Specialties',
  SOCIAL_MEDIAS: 'P360.SocialMedia',

  DISPATCHERS: 'P360.Dispatchers',
  ITEMS: 'P360.Items',
  FORMS: {
    ORDERS: 'P360.Forms.Orders',
    APPOINTMENTS: 'P360.Forms.Appointments',
    STAKEHOLDERS: 'P360.Forms.Stakeholders',
    CUSTOMERS: 'P360.Forms.Customers',
  },
  ACTIVE_CAMPAIGNS: 'P360.ActiveCampaigns',
  CAMPAIGNS: 'P360.Campaign.{ID}',
  CAMPAIGN_RESOURCES: 'P360.CampaignResources.{ID}',

  MY_FORMS: 'P360.MyDynamicForms',

  SESSION: 'P360.Security.Session',
  USER: 'P360.Security.User',
  USERNAME: 'P360.Security.Username',
  COMPANY: 'P360.Security.Company',
  COMPANY_TYPE: 'P360.Security.CompanyType',
  COLLABORATOR: 'P360.Security.Collaborator',
  OPTIONS_MENU: 'P360.Security.OptionsMenu',
  AI_CHAT_HISTORY: 'P360.Global.AiChatHistory_{{DATE}}',

  SETTINGS_LANGUAGE: 'P360.Settings.Language',
  SETTINGS_FORMAT: 'P360.Settings.Format',
  SETTINGS_PRECISION: 'P360.Settings.Precision',

  CACHE_KEYS: 'P360.CacheKeys',

  IS_LOGGED: 'isLogged',
  AGENT: 'agent',
  REST: 'restEndpoints',
  LANGUAGE: 'language',
  CLIENTS_PER_AGENT: 'clientsPerAgent',
  ITEMS_PER_AGENT: 'itemssPerAgent',
  DISPATCHERS_PER_AGENT: 'dispatchersPerAgent',
  PUSH_ID: 'pushId',
  SALESFORCE_RESULT: 'salesforceResult',
  FILTERS_CLIENTS: 'filterClients',
  FILTERS_LINES: 'filterLines',
  FILTERS_SEGMENTS: 'filterSegments',
  FILTERS_SALESFORCE: 'filterSalesforce',
  FILTERS_DASHBOARD_R: 'filterDashboardR',
  REST_ENDPOINTS: 'endpointCalled',
  LICENSE_INFORMATION: 'licenseInformation',
};
